import React from 'react';
import * as Inovx from '@shared';

import LicenseStore from '../stores/LicenseStore';
import LicenseConstants from '../constants/LicenseConstants';
import LicenseActions from '../actions/LicenseActions';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var InovxControls = Inovx.Shared.Controls;

declare var InovxLoader: any;

interface LicenseFormProps {
}

interface LicenseFormState {
    editLicenseKey: string;
    isActionInProgress?: boolean;
    isActionInProgressMsg?: string;
}

var _actionInProgressMsg: string;

function getActionInProgress() {
    return SystemStore.isActionInProgress(LicenseConstants.LICENSE_ADD)
}

function getFormState(): LicenseFormState {
    return {
        editLicenseKey: LicenseStore.getEditLicense(),
        isActionInProgress: getActionInProgress(),
        isActionInProgressMsg: _actionInProgressMsg
    }
}

class LicenseForm extends React.Component<LicenseFormProps, LicenseFormState> {
    constructor(props: LicenseFormProps) {
        super(props);

        this.state = getFormState();
    }

    private _saveLicense = () => {
        LicenseActions.create();
    }

    private _cancel = () => {
        LicenseActions.finishAdd();
    }

    private _checkForUnsavedChanges = (event: any) => {
        if (LicenseStore.getHasChanges()) {
            event.returnValue = InovxLoader.t('common:msgBox.browserSaveChanges');
        }
    }

    private _onChange = (event: any) => {
        LicenseActions.addingLicense(event.name, event.target.value);
    }

    private _loadState = () => {
        this.setState(getFormState());
    }
    private _systemChange = () => {
        this.setState({
            isActionInProgress: getActionInProgress()
        } as any);
    }

    componentDidMount() {
        LicenseStore.addChangeListener(this._loadState);
        SystemStore.addChangeListener(this._systemChange);
        window.addEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    componentWillUnmount() {
        LicenseStore.removeChangeListener(this._loadState);
        SystemStore.removeChangeListener(this._systemChange);
        window.removeEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    render() {
        var header = InovxLoader.t("License:form.newLicense");

        var inputObj = {
            className: 'form-control',
            type: 'text'
        }

        var licenseKeyInput = {
            ...inputObj,
            name: 'LicenseKey',
            value: this.state.editLicenseKey
        };

        return (
            <InovxControls.StaticHeaderForm title={header} saveOnClick={this._saveLicense} cancelOnClick={this._cancel}
                isActionInProgress={this.state.isActionInProgress} inProgressMessage={this.state.isActionInProgressMsg}>

                <InovxControls.FormField title={`${InovxLoader.t('License:form.licenseKey')}*`} inputName='LicenseKey'>
                    <input {...licenseKeyInput} onChange={this._onChange} />
                </InovxControls.FormField>
            </InovxControls.StaticHeaderForm>
        )
    };
}

export default LicenseForm;
